import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  FormHelperText,
  Autocomplete
} from '@mui/material'
import CustomTypography from '../../globalStyles/fonts'
import CloseIcon from '@mui/icons-material/Close'
import { toast } from 'react-toastify'
import { zoneChartService } from '../../utils/services/zoneChartService'

const ZoneChartModal = ({ open, handleClose, onAddData, selectedZoneChart }) => {
  const [zoneChartDetails, setZoneChartDetails] = useState({
    zone: '',
    zipcodes: '',
    origin: '',
    effective_from: ''
  })
  const initialData = () => {
    setZoneChartDetails({
      zone: '',
      zipcodes: '',
      origin: '',
      effective_from: ''
    })
    setFormErrors({})
  }
  const [formErrors, setFormErrors] = useState({})

  const validateForm = () => {
    const errors = {}
    if (!zoneChartDetails.zone) errors.zone = 'Zone is required.'
    if (!zoneChartDetails.zipcodes) errors.zipcodes = 'Code is required.'
    if (!zoneChartDetails.origin) errors.origin = 'Zip is required.'
    if (!zoneChartDetails.effective_from) errors.effective_from = 'Effective from is required.'
    setFormErrors(errors)
    return Object.keys(errors).length === 0
  }

  useEffect(() => {
    if (selectedZoneChart) {
      setZoneChartDetails({
        zone: selectedZoneChart?.zone || '',
        zipcodes: selectedZoneChart?.zipcodes || '',
        origin: selectedZoneChart?.origin || '',
        effective_from: selectedZoneChart?.effective_from || ''
      })
    } else {
      initialData()
    }
  }, [selectedZoneChart])
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setZoneChartDetails((prevData) => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleEditData = async (e) => {
    e.preventDefault()
    if (!validateForm()) return
    try {
      await zoneChartService.edit(
        {
          zone: zoneChartDetails.zone,
          zipcodes: zoneChartDetails.zipcodes,
          origin: zoneChartDetails.origin,
          effective_from: zoneChartDetails.effective_from
        },
        selectedZoneChart._id
      )
      onAddData && onAddData()
      toast.success('Zone edited successfully!')
      initialData()
    } catch (e) {
      console.error(e)
    }
    initialData()
    handleClose()
  }

  const handleSave = async (e) => {
    e.preventDefault()
    if (!validateForm()) return
    try {
      await zoneChartService.create({
        zone: zoneChartDetails.zone,
        zipcodes: zoneChartDetails.zipcodes,
        origin: zoneChartDetails.origin,
        effective_from: zoneChartDetails.effective_from
      })
      onAddData && onAddData()
      toast.success('Zone created successfully!')
      initialData()
      handleClose()
    } catch (e) {
      toast.error('Failed to create Zone.')
      console.error(e)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        initialData()
        handleClose()
      }}
      maxWidth="md"
      aria-labelledby="form-dialog-title"
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <DialogTitle
          id="form-dialog-title"
          style={{
            fontFamily: 'Poppins',
            fontSize: 24,
            fontWeight: 500,
            color: '#000000'
          }}
        >
          {selectedZoneChart ? 'Edit Zone Chart' : 'Create Zone Chart'}
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider style={{ marginBottom: 10 }} />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <CustomTypography>Zone </CustomTypography>
            <TextField
              size="small"
              name="zone"
              value={zoneChartDetails.zone}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.zone}
              helperText={formErrors.zone}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography>Zipcodes</CustomTypography>
            <TextField
              size="small"
              name="zipcodes"
              value={zoneChartDetails.zipcodes}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.zipcodes}
              helperText={formErrors.zipcodes}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography>Origin</CustomTypography>
            <TextField
              size="small"
              name="origin"
              value={zoneChartDetails.origin}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.origin}
              helperText={formErrors.origin}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography>Effective From</CustomTypography>
            <TextField
              type="date"
              size="small"
              name="effective_from"
              value={
                zoneChartDetails.effective_from
                  ? new Date(zoneChartDetails.effective_from).toISOString().split('T')[0]
                  : ''
              }
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.effective_from}
              helperText={formErrors.effective_from}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ paddingBottom: 15, paddingRight: 15 }}>
        <Button
          onClick={() => {
            handleClose()
            initialData()
          }}
          variant="outlined"
          style={{
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 600
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={(e) => (selectedZoneChart ? handleEditData(e) : handleSave(e))}
          variant="contained"
          style={{
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 600
          }}
        >
          {selectedZoneChart ? 'Save' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ZoneChartModal
